import SoftBox from "components/SoftBox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import InvoiceTableHeader from "./InvoiceTableHeader";
import InvoiceTableRow from "./InvoiceTableRow";

function InvoiceTable({ lines, withheldAmount }) {
  return (
    <SoftBox width="100%" overflow="auto">
      <Table sx={{ minWidth: "32rem" }}>
        <InvoiceTableHeader withheldAmount={withheldAmount} />
        <TableBody>
          {lines.map((line) => (
            <InvoiceTableRow
              key={`invoice-line-${line.lineNumber}`}
              data={line}
              withheldAmount={withheldAmount}
            />
          ))}
        </TableBody>
      </Table>
    </SoftBox>
  );
}

export default InvoiceTable;
